import { Query } from '@/_core/cqrs/types/queries';
import { WorkspaceRole } from '@/_core/utils/roles';

export class InitManageProductsQuery extends Query<InitManageProductsResult> {
    constructor() {
        super('InitManageProductsQuery');
    }
}

export class MoveAssetsDialogQuery extends Query<MoveAssetsDialogResult> {
    constructor() {
        super('MoveAssetsDialogQuery');
    }
}

export class MoveAssetsConfirmQuery extends Query<string[]> {
    constructor(
        public FromProductId: string,
        public ToProductId: string,
        public SelectedStorymapIds: string[],
        public SelectedStorymapTemplateIds: string[],
        public SelectedRoadmapIds: string[],
        public SelectedInsightFolderIds: string[],
        public SelectedIdeaLabelIds: string[],
        public ShouldMoveAllInsights: boolean,
        public ShouldMoveAllIdeas: boolean
    ) {
        super('MoveAssetsConfirmQuery');
    }
}

export class DeleteProductQuery extends Query<DeleteProductQueryResult> {
    constructor(public ProductSlug: string) {
        super('DeleteProductQuery');
    }
}

export interface DeleteProductQueryResult {
    StorymapCount: number;
    RoadmapCount: number;
    IdeaCount: number;
    FeedbackCount: number;
}

export interface InitManageProductsResult {
    Products: ManageProductsItem[];
    WorkspaceMembers: WorkspaceMemberModel[];
}

export interface ManageProductsItem {
    Id: string;
    Name: string;
    Slug: string;

    MemberIds: string[];
    GuestIds: string[];
}

export interface WorkspaceMemberModel {
    MemberId: string;
    Name: string;
    Email: string;
    IsInInvitedState: boolean;
    IsMe: boolean;
    WorkspaceRole: WorkspaceRole;
}

export interface MoveAssetsDialogResult {
    Storymaps: MoveAssetsDialogItem[];
    StorymapTemplates: MoveAssetsDialogItem[];
    Roadmaps: MoveAssetsDialogItem[];
    InsightFolders: MoveAssetsDialogItem[];
    IdeaLabels: MoveAssetsDialogItem[];
}

export interface MoveAssetsDialogItem {
    Id: string;
    Name: string;
    ProductId: string;
}
